import React from "react";

export const acionavelPorTeclado = (acionar: (evento: React.SyntheticEvent<HTMLElement>) => void) => ({
  role: "button",
  tabIndex: 0,
  onClick: acionar,
  onKeyDown: (evento: React.KeyboardEvent<HTMLElement>) => {
    if (evento.key === "Enter" || evento.key === " " || evento.key === "Spacebar") {
      evento.preventDefault();
      acionar(evento);
    }
  },
});
